<template>
  <div>
    <div class="text-time">{{ title }}</div>
    <div class="task-content" v-for="task in listNoticeTask" :key="task.id">
      <div
        class="task-content-item d-flex justify-space-between px-1"
        @click="redirectListTask(task)"
      >
        <div class="mr-3">
          <img v-if="task.type === 2" src="./assets/createtask.svg" alt="">
          <img v-if="task.type === 1" src="./assets/comment.svg" alt="">
          <img v-if="task.type === 3" src="./assets/usertag.svg" alt="">
        </div>
        <div class="w-full">
          <div class="content-notice">
            <div>
              <strong>{{task.title}}</strong>
              <span class="name-task mx-2">{{task.content}}</span>
              <strong v-if="task.type === 3">cho bạn</strong>
            </div>
          </div>
          <div class="content-time">{{ formatDateTimeRender(task.created_at) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as moment from 'moment';

export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    listNoticeTask: {
      type: Array,
      default: () => [],
    },
    formatDateTime: {
      type: String,
      default: 'DD/MM/YYYY HH:mm',
    },
  },
  data() {
    return {
      linkImage: [
        './assets/createtask.svg',
        './assets/comment.svg',
        './assets/usertag.svg',
      ],
    };
  },
  methods: {
    redirectListTask(task) {
      this.$emit('redirectListTask', task);
    },
    formatDateTimeRender(date) {
      return moment(date).format(this.formatDateTime);
    },
  },
};
</script>

<style lang="scss" scoped>
.content-notice {
  color: #474747;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.content-time {
  color: #6c6c6c;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding: 8px 0px;
}
.task-content-item {
  padding: 8px 0px;
  cursor: pointer;
  &:hover {
    background: #f2eeee;
    border-radius: 4px;
  }
}
.name-task {
  color: #14bce1 !important;
  font-weight: 400;
}
</style>
